import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallSearchIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M1.472 13.357a9.063 9.063 0 1 0 16.682 -7.09 9.063 9.063 0 1 0 -16.682 7.09"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m16.221 16.22 7.029 7.03"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
